module.exports = __webpack_public_path__ + "img/store_FB.7555ac99.svg";